export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST"
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS"
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL"

export const MY_ORDER_REQUEST = "MY_ORDER_REQUEST"
export const MY_ORDER_SUCCESS = "MY_ORDER_SUCCESS"
export const MY_ORDER_FAIL = "MY_ORDER_FAIL"

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST"
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS"
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL"

export const ADMIN_ORDER_REQUEST = "ADMIN_ORDER_REQUEST"
export const ADMIN_ORDER_SUCCESS = "ADMIN_ORDER_SUCCESS"
export const ADMIN_ORDER_FAIL = "ADMIN_ORDER_FAIL"

export const ADMIN_UPDATE_ORDER_REQUESTS = "ADMIN_UPDATE_ORDER_REQUESTS";
export const ADMIN_UPDATE_ORDER_SUCCESS = "ADMIN_UPDATE_ORDER_SUCCESS";
export const ADMIN_UPDATE_ORDER_FAIL = "ADMIN_UPDATE_ORDER_FAIL";
export const ADMIN_UPDATE_ORDER_RESET = "ADMIN_UPDATE_ORDER_RESET";

export const ADMIN_DELETE_ORDER_REQUESTS = "ADMIN_DELETE_ORDER_REQUESTS";
export const ADMIN_DELETE_ORDER_SUCCESS = "ADMIN_DELETE_ORDER_SUCCESS";
export const ADMIN_DELETE_ORDER_FAIL = "ADMIN_DELETE_ORDER_FAIL";
export const ADMIN_DELETE_ORDER_RESET = "ADMIN_DELETE_ORDER_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS"